// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogSubscribe_wrapper__sdiod"};